import { jsx as C } from "react/jsx-runtime";
const l = ({
  width: o,
  height: t,
  className: n
}) => /* @__PURE__ */ C(
  "svg",
  {
    className: n,
    fill: "none",
    height: t,
    viewBox: "0 0 21 18",
    width: o,
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ C(
      "path",
      {
        d: "M21.002 2.13156C20.2147 2.49433 19.3785 2.73609 18.5209 2.84883C19.4311 2.27224 20.1039 1.38015 20.4141 0.338433C19.5748 0.864845 18.6506 1.23723 17.6838 1.43854C17.2884 0.988772 16.8041 0.628359 16.2623 0.3807C15.7205 0.133041 15.1334 0.00370075 14.5391 0.0010376C13.3739 0.025435 12.266 0.518068 11.4591 1.3706C10.6522 2.22313 10.2124 3.36572 10.2364 4.547C10.233 4.89478 10.2664 5.24192 10.3361 5.58246C8.60704 5.4848 6.91919 5.01005 5.38767 4.19064C3.85615 3.37124 2.51707 2.22645 1.46181 0.834445C1.07574 1.53648 0.873022 2.3269 0.872911 3.13067C0.869279 3.86934 1.0411 4.59804 1.37393 5.25515C1.70676 5.91225 2.19076 6.47844 2.78503 6.90584C2.10092 6.88575 1.43253 6.6934 0.840009 6.34616V6.39568C0.826947 7.42687 1.1619 8.43163 1.78932 9.24338C2.41673 10.0551 3.29891 10.6251 4.28966 10.8588C3.92192 10.9611 3.54201 11.0114 3.1607 11.0083C2.88699 11.0133 2.6136 10.9872 2.34562 10.9305C2.60649 11.8178 3.13479 12.6 3.8564 13.1674C4.578 13.7349 5.45672 14.0591 6.36927 14.0945C4.86294 15.3424 2.97759 16.0244 1.03232 16.025C0.687884 16.0274 0.343683 16.0065 0.0019989 15.9624C1.95353 17.2956 4.25415 18.0056 6.60737 18.001C14.5301 18.001 18.8636 11.077 18.8636 5.07026C18.8636 4.86822 18.8567 4.67528 18.8477 4.48334C19.7003 3.83811 20.4303 3.04125 21.002 2.13156Z",
        fill: "currentColor"
      }
    )
  }
);
export {
  l as Content
};
